var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrictionCoefficient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 297,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 169.6h73s7.4 28.5 29.1 28.5c21.6 0 29.1-19.2 29.7-29.1h89.1s-32.8 67.4-111.4 67.4c-78.5 0-105.1-62.5-109.5-66.8zM10 157.8h39.6L10 148.5v9.3zM20.5 142.3l46.4 9.9-45.2-17.3-1.2 7.4zM13.1 122.5l56.3 24.1L13.7 104l-.6 18.5zM15 85.4l49.5 49.5-34.7-58.7L15 85.4zM44 53.3l27.8 82.3-17.3-84.8L44 53.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.5 102.2c-3.1-11.8-6.8-51.3-27.8-44.6 0 0-22.9-36.5-33.4-37.7-10.5-1.2-17.9 1.9-37.1 6.8-19.2 5-59.4 13.6-57.5 29.1 1.9 15.5-1.9 36.5-1.9 36.5S76.2 104 76.2 110.8c0 6.8 14.9 43.9 14.9 43.9l8 1.2s7.4 24.1 19.8 21.6 13-19.8 6.2-29.7l84.1-23.5s7.4 21.6 17.9 21.6c10.5 0 14.9-16.1 9.3-27.8 0 0-.6-3.7 4.3-5.6 5-1.7 6.9 1.4 3.8-10.3zm-141.4 24.7c-7.7 0-13.9-5.7-13.9-12.7s6.2-12.7 13.9-12.7 13.9 5.7 13.9 12.7c0 7-6.2 12.7-13.9 12.7zm-5.3-36.5s1.2-26.6 2.5-30.9c1.2-4.3 3.7-8 21-14.2 17.3-6.2 35.9-9.9 44.6-11.8 8.7-1.9 12.4-2.5 20.4 4.3 8 6.8 16.1 21.6 16.1 21.6l-104.6 31zM212 97.2c-7.7 0-13.9-5.7-13.9-12.7 0-7 6.2-12.7 13.9-12.7s13.9 5.7 13.9 12.7c0 7-6.2 12.7-13.9 12.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrictionCoefficient);
export default __webpack_public_path__ + "static/media/FrictionCoefficient.1a67d5744b62acb789c7dac769f8b8f9.svg";
export { ForwardRef as ReactComponent };